import ColorSelectionIconButton from './ColorSelectionIconButton';

export default ColorSelectionIconButton;
